<template>
 <div class="v-tabs" :class="{'v-tabs_alternate': alternate}">
  <nav class="v-tabs__header">
   <ul class="v-tabs__list">
    <li class="v-tabs__item"
        :class="{ 'v-tabs__item--is-selected': selectedTabIndex === index }"
        v-for="(tab, index) in tabs"
        @click="selectTab(index)">
     <button class="v-tabs__button" @click.prevent>
      {{ tab[nameBy] }}
     </button>
    </li>
   </ul>
  </nav>
  <v-card :isOpen="true">
    <template slot="header">
      <slot name="documents-header">{{documentsHeader}}</slot>
    </template>
    <div class="v-tabs__body-holder" :class="{'v-tabs__body-holder_tabs-not-activated': tabsNotActivated}">
      <p v-if="fetching">Fetching data...</p>
      <slot v-else name="documents"></slot>
    </div>
  </v-card>
  <v-card :isOpen="true">
    <template slot="header">
      <slot name="documents-header">{{extraInformationHeader}}</slot>
    </template>
    <div class="v-tabs__body-holder" :class="{'v-tabs__body-holder_tabs-not-activated': tabsNotActivated}">
      <p v-if="fetching">Fetching data...</p>
      <slot v-else name="extrainfo"></slot>
    </div>
  </v-card>
  <v-card :isOpen="true">
    <template slot="header">
      <slot name="documents-header">{{signedDocumentsHeader}}</slot>
    </template>
    <div class="v-tabs__body-holder" :class="{'v-tabs__body-holder_tabs-not-activated': tabsNotActivated}">
      <p v-if="fetching">Fetching data...</p>
      <slot v-else name="attachments"></slot>
    </div>
  </v-card>
 </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import VCard from './VCard';
  export default {
    components: {
      VCard,
    },
    data () {
      return {
        tabsNotActivated: true,
        selectedTabIndex: 0
      }
    },
    methods: {
      selectTab (index) {
        if (this.selectedTabIndex != index) {
          let data = this.selectBy ? this.tabs[index][this.selectBy] : this.tabs[index]
          this.$emit('selected', data);
          this.tabsNotActivated = false;
          this.selectedTabIndex = index;
        }
      }
    },
    props: {
      tabs: {
        default: () => [],
        type: Array
      },
      nameBy: {
        default: '',
        type: String
      },
      selectBy: {
        default: '',
        type: String
      },
      alternate: {
        default: false,
        type: Boolean
      },
      documentsHeader: {
        default: '',
        type: String
      },
      signedDocumentsHeader: {
        default: '',
        type: String
      },
      extraInformationHeader: {
        default: '',
        type: String
      },
      fetching: {
        default: true,
        type: Boolean
      }
    }
  }
</script>
